<template>
  <div class="w-100">
		<Mobile 
			v-if="is_mobile_view"
      ref="mobile_view"
      :data_parent="data_to_child"
      :check_status="checkStatus"
      :redeem_ticket="redeemTicket"
      @toggleRedeemWarning="toggleRedeemWarning"
			>
		</Mobile>
		<Desktop 
			v-else
      ref="desktop_view"
      :data_parent="data_to_child"
      :check_status="checkStatus"
      :redeem_ticket="redeemTicket"
      @toggleRedeemWarning="toggleRedeemWarning"
			>
		</Desktop>

    <b-modal ref="warning_redeem" no-close-on-esc no-close-on-backdrop hide-header>
      <div class="py-5 px-4 text-center">
        <div class="mb-4">
          <svg width="140" height="128" viewBox="0 0 140 128" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18.2347 126.908H121.765C133.12 126.908 140 119.027 140 108.807C140 105.668 139.065 102.395 137.395 99.456L85.5629 9.15077C82.0894 3.07252 76.1452 0 69.9997 0C63.8548 0 57.8433 3.07252 54.437 9.15077L2.60496 99.456C0.801527 102.462 0 105.668 0 108.807C0 119.027 6.87976 126.908 18.2347 126.908Z" fill="#EEB815"/>
            <path d="M70.067 82.2901C66.5936 82.2901 64.6568 80.286 64.5895 76.7459L63.7214 40.4103C63.6548 36.8702 66.2595 34.3321 69.9997 34.3321C73.6071 34.3321 76.4119 36.937 76.3452 40.4771L75.3438 76.7459C75.2765 80.3533 73.3398 82.2901 70.067 82.2901ZM70.067 104.666C66.0589 104.666 62.5861 101.46 62.5861 97.5192C62.5861 93.5112 65.9922 90.3056 70.067 90.3056C74.0745 90.3056 77.4812 93.4445 77.4812 97.5192C77.4812 101.527 74.0078 104.666 70.067 104.666Z" fill="white"/>
          </svg>
        </div>

        <p class="mb-0 body-2-2 text-30 text-warning font-bold">Warning</p>
        <p class="mb-0 body-1-2 w-75 mx-auto">Make sure you are in front of the <b>{{ getMerchant.name }}</b> staff when redeeming your ticket</p>
      </div>
      <template slot="modal-footer">
        <div class="w-100">
          <div class="row slim-grid-row">
            <div class="col-5">
              <button class="g-btn g-btn-lg g-btn-dark w-100" @click="cancelRedeem">Cancel</button>
            </div>
            <div class="col-7">
              <state-button variant="primary" block size="lg" :click="redeemTicket">Continue Redeem</state-button>
            </div>
          </div>
        </div>
      </template>
    </b-modal>
	</div>
</template>

<script>
  import Desktop from './TicketPaymentFormDesktop'; 
	import Mobile from './TicketPaymentFormMobile';
  import moment from 'moment'
  import { mapGetters } from 'vuex';
  import { get,post } from '@/services/index'
  
  export default {
    components:{
      Desktop,
      Mobile
    },
    data(){
      return{
        is_load: true,
        error: '',
        data: {},
        payment_still_not_complete: false,
        step: 3,
        redeem:{
          load: false,
          error: '',
          claimed: false
        },
        warning_redeem: false,
        is_valid_to_redeem: true,
        is_expired: false
      }
    },
    computed:{
      ...mapGetters(['getMerchant']),
      is_mobile_view(){
				return window.innerWidth > 768 ? false : true
			},
      tx_order_id(){
        return this.$route.params.tx_order_id
      },
      total(){
        let return_data = {
          qty: 0,
          price: 0,
          with_surcharge: 0
        }
        if(!this.is_load && this.error == ''){
          this.data.ticket_details.forEach(item=>{
            return_data.qty += item.qty
            return_data.price += Number(item.best_price.final_price)*item.qty
          })
          return_data.with_surcharge = Number(this.data.total_payment)+Number(this.data.payment_surcharge)
        }
        return return_data
      },
      data_to_child(){
        return{
          is_load: this.is_load,
          trx:this.data,
          error: this.error,
          payment_still_not_complete: this.payment_still_not_complete,
          total: this.total,
          step: this.step,
          redeem: this.redeem,
          is_valid_to_redeem: this.is_valid_to_redeem,
          is_expired: this.is_expired
        }
      }
    },
    mounted(){
      this.loadFirstData()
    },
    methods:{
      loadFirstData(){
        this.is_load = true
        this.error = ''
        Promise.all([this.loadDetailTrx()])
        .catch(err=>this.error = err)
        .finally(()=>this.is_load = false)
      },
      loadDetailTrx(export_pdf=false){
        return new Promise((success,fail)=>{
          let params = export_pdf ? {
            export_to: 'pdf'
          } : {}
          get("CORE","tx-ticket-detail/"+this.tx_order_id,params).then(response=>{
            let res = response.data;
            if (res.success) {
              if(export_pdf){
                success()
              }else{
                if(res.data.status == 'COMPLETE') {
                  this.step = 4
                  if(this.getMerchant.redeem_type == 'MANUAL'){
                    this.redeem.claimed = res.data.tx_order_adapter.some(x=>x.status == 'CLAIMED')
                  }
                }
                success(res.data)
                this.data = res.data
                let is_manual_and_use_strict = this.getMerchant.redeem_type == 'MANUAL' && this.getMerchant.use_strict_redeem_date
                // let tom = moment().add(1,'d').toDate()
                let is_redeem_date_today = moment(this.$startDate()).isSame(moment(res.data.visit_date,'YYYY-MM-DD'), 'day')
                if(this.data.flexible_service_date_max_late == 0){
                  if(is_manual_and_use_strict && !is_redeem_date_today){
                    this.is_valid_to_redeem = false
                  }
                }else{
                  const visitDate = moment(this.data.visit_date, 'YYYY-MM-DD');
                  const redeemEndDate = moment(this.data.visit_date_max_late, 'YYYY-MM-DD');
                  const currentDate = moment();
                  
                  if(!currentDate.isBetween(visitDate, redeemEndDate, null, '[]')){
                    this.is_valid_to_redeem = false
                    if(currentDate.isAfter(redeemEndDate)){
                      this.is_expired = true
                    }
                  }
                }
                this.data.customer_details.full_name = this.data.customer_details.first_name
                if(this.$isNotEmpty(this.data.customer_details.title)) this.data.customer_details.full_name = `${this.$capitalize(this.data.customer_details.title)}. ${this.data.customer_details.first_name}`
                if(this.$isNotEmpty(this.data.customer_details.last_name)) this.data.customer_details.full_name += ` ${this.data.customer_details.last_name}`
              }
            }else{
              fail(res.message)
            }
          }).finally(()=>{
            success()
          })
        })
      },
      checkStatus(){
        return new Promise((success,fail)=>{
          this.payment_still_not_complete = false
          this.loadDetailTrx()
          .then(res=>{
            if(res.status === 'WAITING_PAYMENT_CONFIRMATION') this.payment_still_not_complete = true
            else if(res.status == 'COMPLETE') this.step = 4
          })
          .finally(()=>success())
        })
      },
      redeemTicket(){
        return new Promise((success,fail)=>{
          this.redeem.load = true
          this.redeem.error = ''
          
          post("CORE","claim-ticket-manual",{
            merchant_id: this.getMerchant.id,
            e_ticket_id: this.data.ticket_code
          }).then(response=>{
            let res = response.data
            if(res.success){
              this.redeem.load = false
              this.redeem.claimed = true
              this.toggleRedeemWarning()
              success()
            }else{
              this.redeem.load = false
              this.redeem.error = res.message
              this.cancelRedeem()
              fail()
            }
          })
        })
      },
      toggleRedeemWarning(){
        this.$refs.warning_redeem.toggle()
      },
      cancelRedeem(){
        this.$refs.warning_redeem.hide()
        let viewtype_function = this.is_mobile_view ? this.$refs.mobile_view : this.$refs.desktop_view
        viewtype_function.resetSlider()
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/pages/ticket/TicketPaymentForm.vue